import { axiosClient } from "../../../services/axiosClient";
import { createApiUrl } from "../../../utils/createApiUrl";
const API_PATH_LOCALIZATION = "localization";
export async function fetchLocalizationPackage(params) {
    const { appId, language, timestamp } = params;
    const url = createApiUrl({
        path: `${API_PATH_LOCALIZATION}/${language}`,
        params: timestamp ? { appId, timestamp } : { appId },
    });
    const response = await axiosClient.get(url);
    return response.data;
}
